import { useEffect, useRef, useState } from 'react';
import svgContent from '../icons/MapIconJS.svg?raw';

const MapWithPulse = () => {
  const containerRef = useRef(null);
  const [svg, setSvg] = useState('');

  useEffect(() => {
    setSvg(svgContent);
  }, []);

  useEffect(() => {
    if (!containerRef.current) return;

    const paths = containerRef.current.querySelectorAll('path.marker-pulse');
    const groupPattern = [1, 2, 3, 4];
    let currentGroupIndex = 0;

    function sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    }

    let isRunning = true;

    async function startPulsing() {
      const pool = Array.from(paths);
      let activeMarkers = new Set();

      while (isRunning) {
        activeMarkers = new Set(
          [...activeMarkers].filter((el) => document.body.contains(el))
        );

        if (activeMarkers.size >= 4) {
          await sleep(1000);
          continue;
        }

        const available = pool.filter((el) => !activeMarkers.has(el));
        if (available.length === 0) {
          await sleep(1000);
          continue;
        }

        const next = available[Math.floor(Math.random() * available.length)];
        activeMarkers.add(next);

        const bbox = next.getBBox();
        const cx = bbox.x + bbox.width / 2;
        const cy = bbox.y + bbox.height / 2;
        const group = next.closest('g') || next.parentNode;

        const glow = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'circle'
        );
        glow.setAttribute('cx', cx);
        glow.setAttribute('cy', cy);
        glow.setAttribute('r', '4');
        glow.setAttribute('class', 'marker-glow pulse-glow');

        const pulse = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'circle'
        );
        pulse.setAttribute('cx', cx);
        pulse.setAttribute('cy', cy);
        pulse.setAttribute('r', '6');
        pulse.setAttribute('class', 'marker-pulse pulse');

        group.appendChild(glow);
        group.appendChild(pulse);

        pulse.addEventListener(
          'animationend',
          () => {
            pulse.remove();
            activeMarkers.delete(next);
          },
          { once: true }
        );

        glow.addEventListener(
          'animationend',
          () => {
            glow.remove();
          },
          { once: true }
        );

        await sleep(800 + Math.random() * 500);
      }
    }

    startPulsing();
    return () => {
      isRunning = false;
    };
  }, [svg]);

  return (
    <div
      ref={containerRef}
      className="mapIcon"
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default MapWithPulse;
